<template>
    <main id="loginGrid">
        <section id="logIn">
          <img id="EcgImg" src="/src/components/icons/Ecg_logo_svg.svg" alt="ECG Image">
            <h1>Welcome to EAP</h1>
            <h3>Log in to your EAP account to get started.</h3>
            <div id="logInFelt">
              <button  @click="handleLogin"><img id="logInIcons" src="/src/components/icons/microsoft_icon.svg" alt="">Sign in with Microsoft</button>
              <!-- <button><img id="logInIcons" src="/src/components/icons/Google.svg" alt="">Sign in with Google</button>
              <button><img id="logInIcons" src="/src/components/icons/envelope.svg" alt=""> Sign in with Email</button> -->
            </div>
        </section>
        <div id="termsOgPrivacy" >
          <a id="terms" href="">Terms of Use</a>
          <a href="">Privacy Policy</a>

        </div>
        
        </main>
</template>

<script>
import { msalService } from '../config/useAuth'

export default {
    methods: {
      async handleLogin() {
        const { login } = msalService(); // destructured login
        login(); // Call the login function
      },
      async initialize() {
        try {
          await msalInstance.initialize();
          registerAuthorizationHeaderInterceptor();
        } catch (error) {
          console.log('Initialization error', error);
        }
      },
    },
};
</script>

<style lang="scss">
#termsOgPrivacy{
  padding: 1%;
}

#terms{
  padding-top: 2rem;
  margin: 2rem;
}

#loginGrid{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: rgba(201, 201, 201, 0.2);
  height: 100vh;

}

#logInIcons{
  width: 25px;
  height: 20px;
  position: relative;
  top: 2px;
  left: -10px; 
}
#logIn{
    background-color: rgb(255, 255, 255);
    width: 35rem;
    height: 35rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-radius: 10px;
    
    h1{
      margin: 2rem 0;
    }

    #logInFelt {
    display: flex;
    flex-direction: column;
    

  button {
    margin: 10% 0;
    padding: 15px;
    background-color: rgb(255, 255, 255);
    border-color: rgb(0, 0, 0);
    border-radius: 5px;
    border-width: 1px;
    width: 200px;
    height: 35px;
    cursor: pointer;
    display: flex;
    gap: 10px;
    align-content: flex-start;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    
    img {
      width: 25px;
      height: 20px;
      position: relative;
      top: 0;
      left: 0;
    }

    span {
      width: auto; /* Adjust span width to content */
      text-align: center;
    }
  }

  button:hover {
    background-color: rgb(211, 211, 211);
  }
}
}

#EcgImg{
  width: 250px;
  height: 150px;
 /*  position: relative;
  top: 7rem;
  left: 0; */

}

body{
  margin: 0px;
  padding: 0px;
}

</style>